import React, { FC } from 'react';
import './styles.css';

const Breadcrumbs: FC = () => {
    const [num, setNum] = React.useState(331231);
    
    return (
        <div className="breadcrumbs">	
            <div className="container">
                <ol>
                    <li><a href="/" className="active blue-color">Home</a> </li>
                    <li><a href="">College Admissions</a></li>
                </ol>
            </div>
	    </div>
    );
};

export default Breadcrumbs;